import { IAssetListsDTO } from "../interfaces/dto/campaign.dto";
import { get } from "./api";
import { APIUrl } from "../config/api-url.config";

export const getIosVersion = (token: string) =>
  get<undefined, IAssetListsDTO>(APIUrl.iosVersion, undefined, token);

export const getAndroidVersion = (token: string) =>
  get<undefined, IAssetListsDTO>(APIUrl.androidVersion, undefined, token);

export const getInterests = (token: string) =>
  get<undefined, IAssetListsDTO>(APIUrl.interest, undefined, token);

export const getAgeGroups = (token: string) =>
  get<undefined, IAssetListsDTO>(APIUrl.ageGroup, undefined, token);

export const getLanguage = (token: string) =>
  get<undefined, IAssetListsDTO>(APIUrl.language, undefined, token);

export const getCountries = () =>
  get<undefined, IAssetListsDTO>(APIUrl.countries, undefined, undefined);

export const getStates = (token: string, country: string) =>
  get<undefined, IAssetListsDTO>(APIUrl.states(country), undefined, token);
